import SERVICES_API_V2 from 'api/services/v2'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  PROCESS_NETWORK_GROUP_ACTION_WITH_CONFIRM,
  REMOVE_AND_FETCH_NETWORK_ACCOUNTS,
  UPDATE_NETWORK_ACCOUNTS_STATUS,
} from 'modules/Services/types'

export const useGroupActionConfig = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const getActionConfig = (groupActionType, props = {}) => {
    switch (groupActionType) {
      case 'archive':
        return {
          groupActionType,
          title: t('services::account_list.confirm_archive_account.heading'),
          text: t(
            'services::account_list.confirm_archive_account.summary',
            props,
          ),
          buttons: {
            apply: t(
              'services::account_list.confirm_archive_accounts.buttons.apply',
            ),
            cancel: t(
              'services::account_list.confirm_archive_accounts.buttons.cancel',
            ),
            attention: true,
          },
          API_CALL: SERVICES_API_V2.archiveNetworkAccountsByIDs,
          startAction: PROCESS_NETWORK_GROUP_ACTION_WITH_CONFIRM,
          postAction: { type: REMOVE_AND_FETCH_NETWORK_ACCOUNTS },
        }

      case 'group_archive':
        return {
          groupActionType,
          title: t('services::account_list.confirm_archive_accounts.heading'),
          text: t('services::account_list.confirm_archive_accounts.summary'),
          buttons: {
            apply: t(
              'services::account_list.confirm_archive_accounts.buttons.apply',
            ),
            cancel: t(
              'services::account_list.confirm_archive_accounts.buttons.cancel',
            ),
            attention: true,
          },
          API_CALL: SERVICES_API_V2.archiveNetworkAccountsByIDs,
          startAction: PROCESS_NETWORK_GROUP_ACTION_WITH_CONFIRM,
          postAction: { type: REMOVE_AND_FETCH_NETWORK_ACCOUNTS },
        }

      case 'group_delete':
        return {
          groupActionType,
          title: t('services::account_list.confirm_delete_accounts.heading'),
          text: t('services::account_list.confirm_delete_accounts.summary'),
          buttons: {
            attention: true,
          },
          API_CALL: SERVICES_API_V2.deleteAccount,
          startAction: PROCESS_NETWORK_GROUP_ACTION_WITH_CONFIRM,
          postAction: {
            type: UPDATE_NETWORK_ACCOUNTS_STATUS,
            payload: {
              needRemoveAccounts: (filters) =>
                filters?.statuses.length > 0 &&
                !filters?.statuses?.includes('deleted'),
              updater: (account, update) => ({
                ...account,
                status:
                  update.status === 'success' ? 'deleted' : account.status,
              }),
            },
          },
        }

      case 'delete':
        return {
          groupActionType,
          title: t('services::account_list.confirm_delete_account.heading'),
          text: t(
            'services::account_list.confirm_delete_account.summary',
            props,
          ),
          buttons: {
            attention: true,
          },
          API_CALL: SERVICES_API_V2.deleteAccount,
          startAction: PROCESS_NETWORK_GROUP_ACTION_WITH_CONFIRM,
          postAction: {
            type: UPDATE_NETWORK_ACCOUNTS_STATUS,
            payload: {
              needRemoveAccounts: (filters) =>
                filters?.statuses.length > 0 &&
                !filters?.statuses?.includes('deleted'),
              updater: (account, update) => ({
                ...account,
                status:
                  update.status === 'success' ? 'deleted' : account.status,
              }),
            },
          },
        }
    }
  }

  const runGroupAction = async ({ groupActionConfig, ids }) => {
    const { data } = await new Promise((resolve, reject) =>
      dispatch({
        type: groupActionConfig.startAction,
        payload: { ...groupActionConfig, ids },
        meta: { resolve, reject },
      }),
    )

    return dispatch({
      type: groupActionConfig.postAction.type,
      payload: {
        groupActionConfig,
        ...(groupActionConfig.postAction.payload ?? {}),
        data,
        ids,
      },
    })
  }

  return [getActionConfig, runGroupAction]
}
